/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;



//////////////////
// WEBPACK FOOTER
// ./~/victory-create-container/~/lodash/_realNames.js
// module id = ./node_modules/victory-create-container/node_modules/lodash/_realNames.js
// module chunks = 1